import http from './http'

function mapPage (res) {
  var page = res.data
  return {
    items: page.content || [],
    total: page.totalElements || 0,
    hasMore: !page.last
  }
}

/**
 * Fetch a paginated list of published songs.
 * Each item includes title, cover art URL, artist list and linked beat.
 * Publicly accessible — no auth required.
 * @param {{ page?: number, size?: number, sort?: string }} params
 */
export function listSongs (params) {
  var query = {
    page: params && params.page > 1 ? params.page - 1 : 0,
    size: (params && params.size) || 20
  }
  if (params && params.sort) query.sort = params.sort

  return http.get('/songs', { params: query }).then(mapPage)
}

/**
 * Get full song detail including cover art, linked artists with roles, and associated beat.
 * Publicly accessible.
 * @param {string} songId
 */
export function getSong (songId) {
  return http.get('/songs/' + songId).then(function (res) {
    return res.data
  })
}
